<template>
  <div class="cart-side-box">
    <div class="num-and-top" :class="{'is-show':showCart}">
      <p class="cart-num" @click="show">
        <img src="../../../static/images/cart_side.png" alt="">
        <span class="cart-text">购物车</span>
        <span class="num">{{ cartNum }}</span>
      </p>
      <p class="to-top" @click="backTop">回到顶部</p>
    </div>
    <div class="cart-side" :class="{'cart-show':showCart}">
      <h1>已加入的商品</h1>
      <div class="cart-list">
        <div v-for="(item,index) in items" :key="index" class="cart-info" style="border-bottom: 1px solid #e3e4e5">
          <b-card no-body class="overflow-hidden" style="max-width: 540px;">
            <b-row no-gutters>
              <b-col md="3">
                <b-card-img :src="item.image" class="rounded-0" />
              </b-col>
              <b-col md="9">
                <b-card-body :title="item.name">
                  <b-card-text class="norm-and-manufature">
                    <span class="cart-norm">{{ item.norm }}</span>
                    <span>{{ item.manufacture }}</span>
                  </b-card-text>
                  <b-card-text>
                    <span class="cart-price">{{ item.price }}</span>
                    <span>X{{ item.num }}</span>
                    <a href="javascript:void(0)" class="cart-delete" @click="remove(item.id)">删除</a>
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </div>
      <div class="go-cart">
        <router-link to="/myCart">
          <img src="../../../static/images/common_cart.png" alt="购物车图标" @click="goCart">
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { ItemService } from '@/service/ItemService'
export default {
  data () {
    return {
      showCart: false,
      status: this.$store.getters.getStatus
    }
  },
  computed: {
    items: function () {
      return this.$store.getters.itemCart
    },
    cartNum: function () {
      var cartNum = this.$store.getters.cartNum
      if (cartNum >= 1000) cartNum = '999+'
      if (cartNum === 0) cartNum = ''
      return cartNum
    }
  },
  watch: {
    items: {
      handler: function (val, oldVal) {
        this.requestItemList()
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    requestItemList () {
      if (this.status === 0) {
        const items = this.items
        const itemService = new ItemService(this.$axios)
        const itemId = items.map((item) => { return item.id })
        itemService.loadFullInfo(itemId).then((itemsInfo) => {
          this.$store.commit('changeStatus', 1)
          this.handleItems(itemsInfo)
        })
      }
    },
    handleItems (items) {
      const itemMap = new Map()
      items.forEach(item => {
        itemMap.set(item.id, item)
      })
      this.items.forEach((item) => {
        item.price = itemMap.get(item.id).promotion.activePrice || item.price
      })
    },
    remove (itemId) {
      this.$store.commit('removeItem', itemId)
      console.log(itemId, 'remove itemdi')
    },
    goCart () {
      this.$router.push({ path: '/myCart' })
    },
    show () {
      this.showCart = !this.showCart
    },
    backTop () {
      document.scrollTop = 0
      document.documentElement.scrollTop = 0
      console.log('回到顶部')
    }
  }
}
</script>
<style>
  .cart-side-box {
    transition: all 0.3s;
  }
  .cart-side {
    position: fixed;
    top: 27px;
    right: 0;
    width: 302px;
    background-color: #fff;
    height: 100%;
    border-bottom: 1px solid #e3e4e5;
    border-left: 1px solid #000;
    z-index: 999;
    display: none;
  }
  .cart-show {
    display: block;
  }
  .cart-side h1 {
    font-size: 14px;
    padding-left: 10px;
    height: 38px;
    color: #f10215;
    background-color: #f5f5f5;
  }
  .cart-side .card-body {
    padding: 0;
    margin-left: 10px;
  }
  .cart-list {
    border-top: 2px solid #f10215;
    background-color: #f5f5f5;
    height:calc(100% - 86px);
    padding-bottom:25px;
    overflow-y: scroll;
  }
  .cart-side .row {
    padding: 10px;
  }
  .cart-side .card {
    border: 0;
    max-height: 106px;
    background-color: #fef4e8;
  }
  .cart-side .card-title {
    margin-bottom: 0;
    text-align: left;
    font-size: 0.75rem;
  }
  .cart-side .card-text {
    margin-bottom: 0;
    text-align: left;
    font-size: 0.75rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .cart-side .norm-and-manufature {
    line-height: 36px;
  }
  .cart-side .cart-norm {
    margin-right: 2px;
  }
  .cart-side .cart-price {
    margin-right: 5px;
    color: #f10215;
    font-size: 0.875rem;
  }
  .cart-side .cart-delete {
    color: #2993f7;
    position: absolute;
    right: 0;
    text-decoration: none;
  }
  .go-cart {
    position:absolute;
    bottom:20px;
    left:0;
    right:0;
    height: 48px;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
  }
  .num-and-top {
    position: fixed;
    bottom: 240px;
    right:0;
    z-index: 999;
    color: #fff;
    font-size: 0.875rem;
  }
  .is-show {
    right: 302px;
  }
  .num-and-top .cart-num {
    position: relative;
    cursor: pointer;
  }
  .cart-num span {
    position: absolute;
  }
  .cart-num .cart-text {
    display: inline-block;
    width: 100%;
    bottom: 0px;
    left: 0;
  }
  .cart-num .num {
  display: inline-block;
  width: 24px;
  max-height: 24px;
  margin: 0 auto;
  left: 16px;
  top: 0px;
  background-color: #f00;
  color: #fff;
  border-radius: 50%;
  font-size: 0.55rem;
  }
  .num-and-top .to-top {
    width: 50px;
    height: 50px;
    padding: 5px 10px;
    box-sizing: border-box;
    background-color: #6c6c6c;
    cursor: pointer;
  }
</style>
